import React from 'react';
import { makeStyles, Divider } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  widgetDivider: {
    height: '70%',
    margin: 'auto 0.5rem',
  },
}));

const GeoWidgetAndFiltersDivider = () => {
  const classes = useStyles();
  return <Divider orientation="vertical" className={`${classes.widgetDivider} widgetDividerOverride`} />;
};
export default GeoWidgetAndFiltersDivider;
